import { render, staticRenderFns } from "./DiagnosisEdit.vue?vue&type=template&id=3c2071c0"
import script from "./DiagnosisEdit.vue?vue&type=script&lang=js"
export * from "./DiagnosisEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports